import React from 'react';

const TitledDivider = ({ title }) => (
  <div className="titled-divider-container">
    <span className="titled-divider-line" />
    <span className="titled-divider-header">{title}</span>
    <span className="titled-divider-line" />
  </div>
);

export default TitledDivider;
